// 모바일 매출 정산일 패치 (테스트용, 변경 가능)
// - 정산(예정)일이 PATCH_DATE 이전이면 구 스킴(1/11/21), 이후면 신 스킴(3/13/23)으로 표시.
// - 신 정산일 = 구 정산일 + 2일 (같은 달, 1→3 / 11→13 / 21→23).
//
// ▼▼▼ 패치 적용일(정산일변경패치일)을 바꾸려면 이 한 줄만 수정 (월은 0-base: 6 = 7월) ▼▼▼
export const 정산일변경패치일 = new Date(2026, 6, 10, 0, 0, 0, 0); // 정산일 변경 패치일 = 2026-07-10
// ▲▲▲

// 정산 연/월(month 0-base) + 구 정산일(oldDay: 21|1|11) → 실제 표시 정산일(day).
//   정산일(= 신 후보 = oldDay+2)이 패치일 이후면 신(oldDay+2), 이전이면 구(oldDay).
export function settlementDay(settleYear, settleMonth, oldDay) {
    const newDay = oldDay + 2; // 23 / 3 / 13
    const newDate = new Date(settleYear, settleMonth, newDay, 0, 0, 0, 0);
    return newDate.getTime() >= 정산일변경패치일.getTime() ? newDay : oldDay;
}

// 주어진 날짜(Date)가 속한 스킴의 정산일 3종 배열.
export function settlementDaysOf(date) {
    return date.getTime() >= 정산일변경패치일.getTime() ? [3, 13, 23] : [1, 11, 21];
}
